import type { AccountResponse, DashboardSummariesResponse } from '@shared/api';
import { PermissionUtils } from './permissionUtils';

export class AccountUtils {
  static getAccountsWithTransactionView = (accounts: AccountResponse[]) =>
    accounts.filter((account) => PermissionUtils.findAccountFlow(PermissionUtils.getAccountFlows(), account.id)?.viewAllTransactions);

  static getAccountIdsWithTransactionView = (accountIds: number[]) =>
    accountIds.filter((accountId) => PermissionUtils.findAccountFlow(PermissionUtils.getAccountFlows(), accountId)?.viewAllTransactions);

  static filterAccounts = (accounts: AccountResponse[]) =>
    accounts.filter((account) => PermissionUtils.findAccountFlow(PermissionUtils.getAccountFlows(), account.id)?.view);

  static filterDashboardAccounts = (accounts: DashboardSummariesResponse[], filters: { searchText?: string; currency?: string }) => {
    let result = accounts;

    result = result.filter((account) => !filters.currency || account.currency === filters.currency);

    if (filters.searchText) {
      const lowerCaseSearchText = filters.searchText.toLowerCase();

      result = result.filter(
        (account) =>
          account.accountName.toLowerCase().includes(lowerCaseSearchText) ||
          account.accountNumber?.toLowerCase().includes(lowerCaseSearchText) ||
          account.currency?.toLowerCase().includes(lowerCaseSearchText) ||
          account.iban?.toLowerCase().includes(lowerCaseSearchText),
      );
    }

    return result;
  };

  static groupedDashboardAccounts = (accounts: DashboardSummariesResponse[]) => {
    const mainAccountsMap = new Map<number, DashboardSummariesResponse>();
    const subAccountsGrouped: Record<number, DashboardSummariesResponse[]> = {};
    const result: { mainAccount: DashboardSummariesResponse; subAccounts: DashboardSummariesResponse[] }[] = [];

    accounts.forEach((account) => {
      if (account.mainAccId === null) {
        mainAccountsMap.set(account.id, account);
        subAccountsGrouped[account.id] = [];
      }
    });

    accounts.forEach((account) => {
      if (account.mainAccId !== null) {
        const parent = mainAccountsMap.get(account.mainAccId);
        if (parent) subAccountsGrouped[account.mainAccId!].push(account);
        else result.push({ mainAccount: account, subAccounts: [] });
      }
    });

    for (const [mainId, mainAccount] of mainAccountsMap.entries()) {
      result.push({ mainAccount, subAccounts: subAccountsGrouped[mainId] || [] });
    }

    return result;
  };
}
